import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop-page">
      <Header />

      <div className="shop-banner">
        <h1>All Products</h1>
      </div>

      <div className="shop-container">

        <div className="shop-main">
          <div className="product-count">
            {productData.length} products
          </div>
          <div className="shop-grid">
            {productData.map(product => (
              <div key={product.id} className="shop-product-card">
                <Link to={`/shopDetails/${product.id}`} onClick={toTop}>
                  <div className="image-container">
                    <img src={product.image} alt={product.name} />
                    <div className="quick-add">QUICK ADD</div>
                  </div>
                  <div className="info">
                    <div className="info-top">
                      <span className="category">{product.category}</span>
                      <span className="price">${product.price}</span>
                    </div>
                    <h3 className="name">{product.name}</h3>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Shop;
